import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  MenuItem,
  Breadcrumbs,
  Link,
  Grid,
  Table,
  Slider,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Popover,
  Modal,
  Pagination,
  Checkbox,
  Select,
  MenuList
} from "@mui/material";
import CloseIcon from "../../assets/landing_page/new/closeicon.svg";
import { useNavigate, useLocation } from "react-router-dom";
import http from "../../utils/http-common";
import { toast } from "react-toastify";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
import {
  Search as SearchIcon,
  ArrowDropDown as ArrowDropDownIcon,
  Edit as EditIcon,
  MoreVert as MoreVertIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
const Progress = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const planId = localStorage.getItem("plan_id");
  const UserId = localStorage.getItem("user_id");
  //const planId = location.state.planId;
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const cellStyle = {
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 500,
    textAlign: "center",
  };
  const dataStyle = {
    fontFamily: "Inter, sans-serif",
    padding: "5px",
    fontSize: "10px",
    fontWeight: 500,
    textAlign: "center",  // Changed from 'left' to 'center'
  };
  const ITEMS_PER_PAGE = 10;


  const [resources, setResources] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [resourceId, setResourceId] = useState({});
  const [userName, setUserName] = useState([]);
  const [emailID, setEmailID] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [resourceData, setResourceData] = useState({
    name: "",
    email: "",
    role_id: "",
  });
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    fetchDetails(planId);
  }, []);

  const fetchDetails = async () => {
    try {
      const payload = {
        plan_id: planId
      };
      const response = await http.post("master_service/task/progress/latest/details", payload);
      if (response.data?.data?.length > 0) {
        const fetchedResources = response.data.data
          // .filter(item => item.plan_id === planId)
          .map((item, index) => ({
            id: index + 1,
            task_id: item?.task_id || "",
            task_name: item?.task_name || "",
            updated_date: item?.updatedAt ? new Date(item.updatedAt).toLocaleString('en-GB', {
              day: '2-digit',
              month: 'short',
              year: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true
            }) : "",
            resource: item?.assigned_to || "",
            user_id: item?.user_id || "", // Add user_id from API response
            start_date: item?.taskDetail?.start_date ? new Date(item.taskDetail.start_date).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short',
              year: '2-digit'
            }) : "",
            end_date: item?.taskDetail?.end_date ? new Date(item.taskDetail.end_date).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short',
              year: '2-digit'
            }) : "",
            latest_ETD: item?.etd ? new Date(item.etd).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short',
              year: '2-digit'
            }) : "",
            latest_progress: item?.task_progress || "",
            pm_updated_progress: item?.pm_updated_progress || "",
            status: item?.status || "",
          }));
        setResources(fetchedResources);
        setOriginalData(fetchedResources); // Store original data
        } else {
        setResources([]);
        setOriginalData([]);
      }
    } catch (error) {
      console.error("Error fetching resources:", error);
      setResources([]);
      setOriginalData([]);
    }
  };
  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  const handleSort = (type) => {
    const sortedResources = [...resources].sort((a, b) => {
      const dateA = new Date(a.updated_date);
      const dateB = new Date(b.updated_date);

      if (type === 'latest') {
        return dateB - dateA; // Latest first
      } else {
        return dateA - dateB; // Oldest first
      }
    });

    setResources(sortedResources);
    setSortAnchorEl(null);
  };

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);

    if (query.trim() === "") {
      setResources(originalData);
    } else {
      const filtered = originalData.filter(resource =>
        resource.task_name.toLowerCase().includes(query) ||
        resource.resource.toLowerCase().includes(query) ||
        resource.status.toLowerCase().includes(query)
      );
      setResources(filtered);
    }
  };
  const handleFilter = (type) => {
    if (type === 'Review Completed') {
      const filtered = originalData.filter(resource =>
        resource.status === "Updated"
      );
      setResources(filtered);
    } else if (type === 'Review Pending') {
      const filtered = originalData.filter(resource =>
        resource.status !== "Updated"
      );
      setResources(filtered);
    } else {
      setResources(originalData);
    }
    setFilterAnchorEl(null);
  };

  const [selectedRows, setSelectedRows] = useState([]);

  // Add this handler function
  const handleRowSelect = (id) => {
    setSelectedRows(prev => {
      if (prev.includes(id)) {
        return prev.filter(rowId => rowId !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const [taskLogData, setTaskLogData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const handleTaskLog = async () => {
    try {
      const payload = {
        task_id: resourceId.task_id,
        plan_id: planId
      };
      const response = await http.post("master_service/task/progress/log/details", payload);
      setTaskLogData(response.data?.data || []);
      // Set the first user as default selected user
      if (response.data?.data?.length > 0) {
        setSelectedUser(response.data.data[0].taskDetail.user_id);
      }
      handleOpen2();
    } catch (error) {
      console.error("Error fetching task log:", error);
      toast.error("Failed to fetch task log");
    }
  };
  const handleSelectUserLog = async (userId) => {
    try {
      setSelectedUser(userId); // Update selected user immediately for UI feedback

      const payload = {
        task_id: resourceId.task_id,
        plan_id: planId,
        //user_id: userId  // Use the selected userId instead of UserId
      };

      const response = await http.post("master_service/task/progress/log/details", payload);

      if (response.data?.data) {
        // Update task log data with the new response
        setTaskLogData(response.data.data);
      } else {
        setTaskLogData([]);
        toast.warning("No log data found for this user");
      }
    } catch (error) {
      console.error("Error fetching task log:", error);
      toast.error("Failed to fetch task log");
      setTaskLogData([]); // Clear data on error
    }
  };
  const getProgress = (log) => {
    const val = log.pm_updated_progress ?? log.task_progress ?? log.taskDetail?.progress ?? 0;
    return Number(val) || 0; // Fallback to 0 if NaN
  };
  const sortedLogs = [...taskLogData]
  .filter(
    (log) =>
      log.taskDetail &&
      String(log.taskDetail.user_id) === String(selectedUser)
  )
  .map(log => ({
    ...log,
    _sortValue: getProgress(log),
  }))
  .sort((a, b) => b._sortValue - a._sortValue);
  
  const [page, setPage] = useState(1);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  const paginatedResources = resources.slice(startIndex, startIndex + ITEMS_PER_PAGE);


  const handleNavigate = () => {
    navigate("/home/myplans");
  };

  const handleUpdate = async () => {
    let payload;
    if (!resourceId) {
      toast.error("Update data is missing.");
      return;
    }
    payload = {
      plan_id: planId,
      task_id: resourceId.task_id,
      user_id: resourceId.user_id,
      progress: String(resourceId.latest_progress),
      etd: (() => {
        const [day, month, year] = resourceId.latest_ETD.split(' ');
        const monthIndex = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(month) + 1;
        return `20${year}-${monthIndex.toString().padStart(2, '0')}-${day}`;
      })()
    };
    try {
      const response = await http.post("master_service/task/progress/updatedby/pm", payload);
      toast.success(
        <>
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
            }}>
            Progress updated successfully
          </div>
        </>,
        {
          icon: (
            <img
              src={tick}
              alt='Success Icon'
              style={{ width: "20px", height: "20px", color: "#0057D5" }}
            />
          ),
        }
      );
      setOpen1(false);
      setAnchorEl(null);
      await fetchDetails(planId);
      navigate("/home/viewplan", { state: { activeTab: 2 } });
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed");
    }
  };

  const handleInputChange = (field, value) => {
    setResourceData((prev) => ({ ...prev, [field]: value }));
  };

  const handleActionOpen = (event, id, resource) => {
    setResourceId({
      ...resource,
      user_id: resource.user_id // This ensures user_id is included in resourceId
    });
    setAnchorEl(event.currentTarget);
  };
  const handleCloseAction = () => {
    setAnchorEl(null);
  };
  const handleOpen = () => {
    setOpen1(true); // Only open if it's not being dragged
  };
  const handleClose = () => {
    setOpen1(false);
  };
  const handleOpen1 = () => {
    setOpen2(true); // Only open if it's not being dragged
  };
  const handleClose1 = () => {
    setOpen2(false);
  };
  const handleOpen2 = () => {
    setOpen3(true); // Only open if it's not being dragged
  };
  const handleClose2 = () => {
    setOpen3(false);
  };
  const [bulkUpdateData, setBulkUpdateData] = useState([]);

  const handleBulkUpdate = async () => {
    try {
      const selectedTasks = paginatedResources
        .filter(resource => selectedRows.includes(resource.id))
        .map(resource => ({
          plan_id: planId,
          user_id: resource.user_id,  // Using user_id from the resource
          task_id: resource.task_id
        }));

      const payload = {
        tasks: selectedTasks
      };
      const response = await http.post("/master_service/task/bulkupdate/status/bypm", payload);
      toast.success("Bulk update successful");
      setOpen1(false);
      await fetchDetails(planId);
      navigate("/home/viewplan", { state: { activeTab: 2 } });
    } catch (error) {
      console.error("Error fetching task log:", error);
    }
  };

  return (
    <Container maxWidth={false}  sx={{ 
    width: "100%",
    paddingLeft: "0 !important",
    paddingRight: "0 !important"
}}>
      <div
        style={{
          fontFamily: "Inter, sans-serif",
          fontSize: "16px",
          fontWeight: 600,
          lineHeight: "21px",
          marginLeft: "8px",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="h6" sx={{ fontSize: "16px" }}>Task Progress</Typography>
          <Box display="flex" alignItems="center" gap={2}>
            <TextField
              size="small"
              placeholder="Search tasks..."
              value={searchQuery}
              onChange={handleSearch}
              InputProps={{
                startAdornment: <SearchIcon sx={{ color: 'gray', mr: 1 }} />,
                sx: {
                  fontSize: '12px',
                  height: '32px',
                  width: '200px'
                }
              }}
            />
            <Button
              endIcon={<ArrowDropDownIcon />}
              sx={{
                textTransform: 'none',
                fontSize: '12px',
                color: 'black',
                border: '1px solid #E0E0E0',
                height: '32px'
              }}
              onClick={(e) => setSortAnchorEl(e.currentTarget)}
            >
              Sort
            </Button>
            <Button
              endIcon={<ArrowDropDownIcon />}
              sx={{
                textTransform: 'none',
                fontSize: '12px',
                color: 'black',
                border: '1px solid #E0E0E0',
                height: '32px'
              }}
              onClick={(e) => setFilterAnchorEl(e.currentTarget)}
            >
              Filter
            </Button>
            {selectedRows.length > 0 && (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#FF2800",
                  color: "white",
                  textTransform: "capitalize",
                  fontSize: '12px',
                  height: '32px',
                  '&:hover': {
                    backgroundColor: "#cc2000"
                  }
                }}
                onClick={() => handleBulkUpdate()}
              >
                Bulk Update
              </Button>
            )}
          </Box>
        </Box>
      </div>
      <div>

        <TableContainer component={Paper}>
          <Table size="small" sx={{ minWidth: 150 }} aria-label="user table">
            <TableHead sx={{ backgroundColor: "#e0eaff", height: "30px" }}>
              <TableRow>
                {resources.length > 0 && (
                  <TableCell padding="checkbox" sx={cellStyle}>
                    <Checkbox
                      disabled={paginatedResources.length === 0}
                      indeterminate={selectedRows.length > 0 && selectedRows.length < paginatedResources.length}
                      checked={paginatedResources.length > 0 && selectedRows.length === paginatedResources.length}
                      onChange={() => {
                        if (selectedRows.length === paginatedResources.length) {
                          setSelectedRows([]);
                        } else {
                          setSelectedRows(paginatedResources.map(r => r.id));
                        }
                      }}
                    />
                  </TableCell>
                )}
                <TableCell sx={cellStyle}>Task Name</TableCell>
                <TableCell sx={cellStyle}>Updated Date & Time</TableCell>
                <TableCell sx={cellStyle}>Resource</TableCell>
                <TableCell sx={cellStyle}>Latest ETD</TableCell>
                <TableCell sx={cellStyle}>Latest Progress</TableCell>
                <TableCell sx={cellStyle}>Status</TableCell>
                {resources.length > 0 && <TableCell sx={cellStyle} />}
              </TableRow>
            </TableHead>

            {paginatedResources.length > 0 ? (
              <TableBody>
                {paginatedResources.map((resource, index) => {
                  const endDate = resource.end_date ? new Date((() => {
                    const [day, month, year] = resource.end_date.split(' ');
                    const monthIndex = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(month) + 1;
                    return `20${year}-${monthIndex.toString().padStart(2, '0')}-${day.padStart(2, '0')}`;
                  })()) : null;

                  const latestETD = resource.latest_ETD ? new Date((() => {
                    const [day, month, year] = resource.latest_ETD.split(' ');
                    const monthIndex = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(month) + 1;
                    return `20${year}-${monthIndex.toString().padStart(2, '0')}-${day.padStart(2, '0')}`;
                  })()) : null;

                  // Reset time parts and convert to UTC for accurate comparison
                  const endDateUTC = endDate ? new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())) : null;
                  const latestETDUTC = latestETD ? new Date(Date.UTC(latestETD.getFullYear(), latestETD.getMonth(), latestETD.getDate())) : null;
                  const isOverdue = endDateUTC && latestETDUTC && latestETDUTC > endDateUTC;
                  return (
                    <TableRow
                      key={resource.id}
                      sx={{
                        height: "10px",
                        backgroundColor: isOverdue ? '#ffebee' : 'inherit'
                      }}
                    >
                      {paginatedResources.length > 0 && (
                        <TableCell padding="checkbox" align="center">
                          <Checkbox
                            checked={selectedRows.includes(resource.id)}
                            onChange={() => handleRowSelect(resource.id)}
                          />
                        </TableCell>
                      )}
                      <TableCell sx={dataStyle}>{resource.task_name}</TableCell>
                      <TableCell sx={dataStyle}>{resource.updated_date}</TableCell>
                      <TableCell sx={dataStyle}>{resource.resource}</TableCell>
                      <TableCell sx={dataStyle}>{resource.latest_ETD}</TableCell>
                      <TableCell sx={dataStyle}>{resource.pm_updated_progress ? `${resource.pm_updated_progress}%` : resource.latest_progress ? `${resource.latest_progress}%` : ''}</TableCell>
                      <TableCell sx={dataStyle}>
                        {resource.status && (
                          <Box display="flex" justifyContent="center">
                            <Button
                              variant='outlined'
                              sx={{
                                color: resource.status === "Updated" ? "green" : "red",
                                borderColor: resource.status === "Updated" ? "green" : "red",
                                textTransform: "none",
                                borderRadius: "12px",
                                fontSize: "12px",
                                padding: "2px 8px",
                                cursor: "default",
                              }}
                            >
                              {resource.status === "Updated" ? "Review Completed" : "Review Pending"}
                            </Button>
                          </Box>
                        )}
                      </TableCell>
                      {paginatedResources.length > 0 && (
                        <TableCell align="center">
                          <IconButton onClick={(event) => handleActionOpen(event, resource.id, resource)}>
                            <MoreVertIcon sx={{ height: "20px", width: "20px" }} />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  )
                })}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
                    <Typography sx={{ fontSize: '14px', color: '#666' }}>
                      No task progress details
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Box display="flex" justifyContent="center" sx={{ mt: 2 }}>
          {/* <Pagination count={10} color="primary" /> */}
          <Pagination
            count={Math.ceil(resources.length / ITEMS_PER_PAGE)}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      </div>
      <Popover
        id="user-options-popover"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseAction}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box sx={{ p: 1, width: "150px" }}>
          <>
            {resourceId.status !== "Updated" && (
              <Button onClick={handleOpen} fullWidth sx={{ justifyContent: "flex-start", color: "black" }}>
                <EditIcon fontSize="small" sx={{ mr: 1 }} />
                <Typography variant="body1" sx={{ fontSize: "12px", textTransform: "capitalize", fontWeight: 500 }}>Update Progress</Typography>
              </Button>
            )}
            <Button onClick={handleTaskLog} fullWidth sx={{ justifyContent: "flex-start", color: "black" }}>
              <VisibilityIcon fontSize='small' sx={{ mr: 1 }} />
              <Typography variant="body1" sx={{ fontSize: "12px", textTransform: "capitalize", fontWeight: 500 }}>View Log</Typography>
            </Button>
          </>
        </Box>
      </Popover>
      <Modal open={!!open1} onClose={handleClose} resourceId={resourceId}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "370px", // Reduced width slightly
            height: "200px", // Reduced height
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px",
          }}
        >
          {/* Close Icon */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "grey",
            }}
          >
            <img
              src={CloseIcon}
              alt="closeIcon"
              style={{ width: "20px", height: "20px" }}
            />
          </IconButton>

          {/* Form Fields */}
          <Box sx={{ width: "100%", mt: -2 }}>
            <Typography style={{ fontSize: "14px", fontWeight: 600 }} gutterBottom>
              Update Task Progress
            </Typography>
            <Typography style={{ fontSize: "10px", fontWeight: 500 }} gutterBottom>
              Expected Time of Delevery (ETD)
            </Typography>
            <TextField
              sx={{ width: "100%", mb: 2 }}
              size="small"
              type="date"
              placeholder="Expected Time of Delivery (ETD)"
              value={resourceId?.latest_ETD ?
                (() => {
                  const [day, month, year] = resourceId.latest_ETD.split(' ');
                  const monthIndex = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(month) + 1;
                  return `20${year}-${monthIndex.toString().padStart(2, '0')}-${day}`;
                })()
                : ""}
              onChange={(e) => {
                const date = new Date(e.target.value);
                const formattedDate = date.toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'short',
                  year: '2-digit'
                });
                setResourceId({ ...resourceId, latest_ETD: formattedDate });
              }}
              InputProps={{
                sx: { height: 30, fontSize: "12px" }
              }}
            />

            <Typography style={{ fontSize: "10px", fontWeight: 500, mt: 1 }} gutterBottom>
              Progress
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Slider
                sx={{
                  width: "100%",
                  '& .MuiSlider-thumb': {
                    height: 20,
                    width: 20,
                    color: 'black',
                  },
                  '& .MuiSlider-track': {
                    height: 6,
                    color: 'black',
                  },
                  '& .MuiSlider-rail': {
                    height: 6,
                    color: 'black',
                  },
                  '& .MuiSlider-mark': {
                    color: 'black',
                  },
                  '& .MuiSlider-markLabel': {
                    color: 'black',
                  }
                }}
                value={resourceId?.latest_progress || 0}
                onChange={(e, newValue) => {
                  setResourceId({
                    ...resourceId,
                    latest_progress: newValue
                  });
                }}
                step={25}
                marks={[
                  { value: 0, label: '0%' },
                  { value: 25, label: '25%' },
                  { value: 50, label: '50%' },
                  { value: 75, label: '75%' },
                  { value: 100, label: '100%' }
                ]}
                min={0}
                max={100}
              />
            </Box>
          </Box>

          {/* Submit Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
            <Button
              variant="contained"
              style={{
                backgroundColor: "#FF2800",
                color: "white",
                padding: "3px 10px",
                textTransform: "capitalize",
                cursor: "pointer",
              }}
              onClick={handleUpdate}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={!!open3} onClose={handleClose2} resourceId={resourceId} sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
      }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
          },
        }}>
        <Box
          sx={{
            position: "relative",
            width: "320px",
            height: '100%',
            bgcolor: "background.paper",
            boxShadow: '-4px 0 8px rgba(0, 0, 0, 0.1)',
            p: 4,
            transform: 'none',
            right: 0,
            top: 0,
            overflowY: 'auto',
            animation: open3 ? 'slideIn 0.3s ease-out' : 'slideOut 0.3s ease-out',
            '@keyframes slideIn': {
              from: {
                transform: 'translateX(100%)',
                opacity: 0,
              },
              to: {
                transform: 'translateX(0)',
                opacity: 1,
              },
            },
            '@keyframes slideOut': {
              from: {
                transform: 'translateX(0)',
                opacity: 1,
              },
              to: {
                transform: 'translateX(100%)',
                opacity: 0,
              },
            },
          }}
        >
          <IconButton
            onClick={handleClose2}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "grey",
            }}
          >
            <img src={CloseIcon} alt='closeIcon' style={{ width: "20px", height: "20px" }} />
          </IconButton>

          <Box sx={{ width: "100%", mt: -2 }}>
            <Box sx={{ mb: 3 }}>
              <Typography style={{ fontSize: "12px", fontWeight: 500, marginBottom: '8px' }}>
                View Log
              </Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                {taskLogData[0]?.task_name || 'N/A'}
              </Typography>
            </Box>
            {/* Modify the existing task details section to show selected user's data */}
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Box sx={{ display: 'grid', gridTemplateColumns: '100px 1fr', gap: 2 }}>
                  <Typography sx={{
                    fontSize: "12px",
                    fontWeight: 500,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}>
                    <img
                      src={require("../../assets/landing_page/new/user.png")}
                      alt="user"
                      width={16}
                      height={16}
                      style={{ display: 'block' }}
                    />
                    Resource
                  </Typography>
                  <Typography sx={{ fontSize: "12px", fontWeight: 500, display: 'flex', alignItems: 'center', gap: 0.7, flexWrap: 'wrap' }}>
                  {Array.from(new Set(taskLogData.map(log => log.taskDetail?.assigned_to)))
    .filter(Boolean)
    .map((assignedTo, index) => {
      const log = taskLogData.find(l => l.taskDetail?.assigned_to === assignedTo);
      return (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mr: 1 }}>
          {log.users?.uploaded_picture_path ? (
            <img src={log.users.uploaded_picture_path} alt="profile" width={16} height={16} style={{ borderRadius: '50%' }} />
          ) : (
            <img src={require("../../assets/landing_page/new/pro.jpeg")} alt="default profile" width={18} height={18} />
          )}
          <span>{assignedTo || 'Not Assigned'}</span>
        </Box>
      );
    })}
</Typography>
                  <Typography sx={{
                    fontSize: "12px", fontWeight: 500, display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}>
                    <img src={require("../../assets/landing_page/new/time-fill.png")} alt="tests" width={16} height={16} style={{ display: 'block' }} /> Duration
                  </Typography>
                  <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                    {taskLogData[0]?.taskDetail?.task_duration ?
                      `${parseFloat(taskLogData[0]?.taskDetail?.task_duration)} ${parseFloat(taskLogData[0].taskDetail.task_duration) === 1 ? 'day' : 'days'}`
                      : 'N/A'}
                  </Typography>

                  <Typography sx={{
                    fontSize: "12px", fontWeight: 500, display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}>
                    <img src={require("../../assets/landing_page/new/dateicon.png")} alt="user" width={16} height={16} style={{ display: 'block' }} /> Start Date
                  </Typography>
                  <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                    {new Date(taskLogData[0]?.taskDetail?.start_date).toLocaleDateString() || 'N/A'}
                  </Typography>

                  <Typography sx={{
                    fontSize: "12px", fontWeight: 500,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}>
                    <img src={require("../../assets/landing_page/new/dateicon.png")} alt="user" width={16} height={16} style={{ display: 'block' }} /> End Date
                  </Typography>
                  <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                    {new Date(taskLogData[0]?.taskDetail?.end_date).toLocaleDateString() || 'N/A'}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box sx={{
              pt: 2,
              borderTop: '1px solid #e0e0e0',
              maxHeight: '350px',
              overflowY: 'auto',
              overflowX: 'hidden',
              scrollbarWidth: 'thin', // For Firefox
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
}}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                  Update Log
                </Typography>
                {taskLogData.length > 0 && (() => {
  // Step 1: Get logs that have updates AND valid taskDetail with user_id
  const validLogsWithUpdates = taskLogData.filter(log =>
    (log.updated_by || log.admin_updated_by) &&
    log.taskDetail &&
    log.taskDetail.user_id
  );

  // Step 2: Get unique taskDetail users by user_id
  const uniqueUsers = validLogsWithUpdates
    .map(log => log.taskDetail)
    .filter((td, index, self) =>
      index === self.findIndex(t => t.user_id === td.user_id)
    );

  // Step 3: Show dropdown only if 2 or more users
  if (uniqueUsers.length < 2) return null;

                  return (
                    <Box sx={{ width: '100px' }}>
                      <Select
                        size="small"
                        value={selectedUser || ''}
                        onChange={(e) => handleSelectUserLog(e.target.value)}
                        fullWidth
                        sx={{ fontSize: '12px' }}
                      >
                        {uniqueUsers.map((user) => (
                          <MenuItem
                          key={user.user_id}
                          value={user.user_id}
                          sx={{ fontSize: '12px' }}
                        >
                          {user.assigned_to || `User ${user.user_id}`}
                        </MenuItem>
                        ))}
                      </Select>
                    </Box>
                  );
                })()}
              </Box>

              <Box sx={{ minHeight: '100px', position: 'relative' }}>
                <Box sx={{
                  position: 'absolute',
                  left: '5px',
                  top: '10px',
                  height: '80%',
                  width: '2px',
                  bgcolor: '#e0e0e0'
                }} />

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, position: 'relative', py: 1 }}>
                {sortedLogs.map((log, index) => (
                      <React.Fragment key={index}>
                        {/* Show PM update if both admin_updated_by and pm_updated_progress exist */}
                        {log.admin_updated_by && log.pm_updated_progress && (
                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, pl: "-5px" }}>
                            <Box sx={{
                              width: '12px',
                              height: '12px',
                              bgcolor: 'gray',
                              borderRadius: '50%',
                              flexShrink: 0,
                              mt: '10px',
                              zIndex: 1
                            }} />
                            <Box>
                              <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>
                                Task Completed {log.pm_updated_progress}%
                              </Typography>
                              <Typography sx={{ fontSize: '10px', color: '#666' }}>
                                Latest ETD: {new Date(log.etd).toLocaleDateString()} • Updated by {log.admin_updated_by}
                              </Typography>
                            </Box>
                          </Box>
                        )}

                        {/* Show user update if both updated_by and task_progress exist */}
                        {log.updated_by && log.task_progress && (
                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, pl: "-5px" }}>
                            <Box sx={{
                              width: '12px',
                              height: '12px',
                              bgcolor: 'gray',
                              borderRadius: '50%',
                              flexShrink: 0,
                              mt: 0.5,
                              zIndex: 1
                            }} />
                            <Box>
                              <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>
                                Task Completed {log.task_progress}%
                              </Typography>
                              <Typography sx={{ fontSize: '10px', color: '#666' }}>
                                Latest ETD: {new Date(log.etd).toLocaleDateString()} • Updated by {log.updated_by}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </React.Fragment>
                    ))}
                </Box>
              </Box>
            </Box>
            
          </Box>
        </Box>
      </Modal>
      {/* Add these Popover components just before the TableContainer */}
      <Popover
        open={Boolean(sortAnchorEl)}
        anchorEl={sortAnchorEl}
        onClose={() => setSortAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList>
          <MenuItem onClick={() => handleSort('latest')} sx={{ fontSize: '12px' }}>Latest</MenuItem>
          <MenuItem onClick={() => handleSort('old')} sx={{ fontSize: '12px' }}>Old</MenuItem>
        </MenuList>
      </Popover>

      <Popover
        open={Boolean(filterAnchorEl)}
        anchorEl={filterAnchorEl}
        onClose={() => setFilterAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList>
          <MenuItem onClick={() => handleFilter('Review Completed')} sx={{ fontSize: '12px' }}>Updated Task</MenuItem>
          <MenuItem onClick={() => handleFilter('Review Pending')} sx={{ fontSize: '12px' }}>Not Updated Task</MenuItem>
        </MenuList>
      </Popover>
    </Container>
  );
};

export default Progress;
